import { useState, useEffect } from "react";
import Modal from "../modal";
import Cookies from "universal-cookie";
//import { getPantallaActivos, ValidarPantalla } from "../../services/public/screen";
import Toasts from "../toast";
import PropTypes from 'prop-types';
import Icon from "../../Icons/general/Icon";

function ScreenConfig({ show, handleshow}) 
{
    const [voceId, setVoceId] = useState(0);
    const [voices, setVoices] = useState([]);
    const [selectedVoice, setSelectedVoice] = useState(null);
    const [texto, setTexto] = useState("Hola, bienvenido");
    const [showToast, setShowToast] = useState(false);
    const [opciones, setOpciones] = useState([]);
    const [habilita, setHabilita] = useState(false);
    const [pitch, setPitch] = useState(1.2);
    const [volume, setVolume] = useState(1);
    const [rate, setRate] = useState(0.8);
    const [celdas, setCelda] = useState(8);
    const [celdHeight, setHeight] = useState(8);
    
    const cookies = new Cookies(); 
    
    useEffect(() => 
     {
      const synth = window.speechSynthesis;
      const loadVoices = () => 
        {
           const voicesList = synth.getVoices();
           setVoices(voicesList);

        };

      if (synth.getVoices().length > 0) 
       {
        loadVoices();
       } 
      else 
       {
         synth.onvoiceschanged = loadVoices;
       }
         
        setHeight(cookies.get('Ctrheig'));
        setCelda(cookies.get('Ctrceld'));
        
        if (cookies.get('Ctrpitch') && cookies.get('Ctrpitch')!=='')
          setPitch(cookies.get('Ctrpitch'));
        
        if (cookies.get('Ctrvolume') && cookies.get('Ctrvolume')!=='')
          setVolume(cookies.get('Ctrvolume'));
        
        if (cookies.get('Ctrrate') && cookies.get('Ctrrate')!=='')
          setRate(cookies.get('Ctrrate'));
        
        if (cookies.get('Ctrvoice') && cookies.get('Ctrvoice')!=='')
          setSelectedVoice(cookies.get('Ctrvoice'));

     }, []);

     useEffect(() => 
        {
           const savedVoiceName = cookies.get('Ctrvoice');
           if (savedVoiceName && voices.length > 0) 
             {
                 const matchedVoice = voices.find(v => v.name === savedVoiceName);
                if (matchedVoice) 
                 {
                   setSelectedVoice(matchedVoice);
                 }
                else
                {
                   const defaultVoice = voices.find(voice => voice.default) || voices[0];
                   setSelectedVoice(defaultVoice);
                } 
             }
             else
             {
              if (voices.length > 0)
              {
                 const defaultVoice = voices.find(voice => voice.default) || voices[0];
                 console.log(defaultVoice);
                  setSelectedVoice(defaultVoice);
              }
             }
}, [voices]); 
  
  //------------
  const handleVoiceChange = (e) => 
    {
      const voice = voices.find(v => v.name === e.target.value);
      setSelectedVoice(voice);
    };

  //-----------
  const speak = () => 
    {
      if (selectedVoice && texto.trim() !== "") 
        {
          const utterance = new SpeechSynthesisUtterance(texto);
          utterance.voice = selectedVoice;
          utterance.pitch = pitch;
          utterance.volume = volume;
          utterance.rate = rate;
          window.speechSynthesis.speak(utterance);
        }
    };

  //------
  const handleAceptar = async() => 
    {
      setHabilita(true);
      cookies.set('Ctrvoice',selectedVoice.name, { path: "/",maxAge: 60 * 60 * 24 * 365 * 20});
      cookies.set('Ctrpitch',pitch, { path: "/",maxAge: 60 * 60 * 24 * 365 * 20 });
      cookies.set('Ctrvolume',volume, { path: "/",maxAge: 60 * 60 * 24 * 365 * 20});
      cookies.set('Ctrrate',rate, { path: "/",maxAge: 60 * 60 * 24 * 365 * 20});
      cookies.set('Ctrceld',celdas, { path: "/",maxAge: 60 * 60 * 24 * 365 * 20});
      cookies.set('Ctrheig',celdHeight, { path: "/",maxAge: 60 * 60 * 24 * 365 * 20 });
      setHabilita(false);
      handleshow(false);
    }
  
  //-------  
  const handleCancel = async() => 
    {
        handleshow(false);
    }
    return (
        <>
          <Modal isOpen={show} onClose={()=>handleshow(false)} title={'Configurar Pantalla'}>
              <div className="flex lg:w-[24rem] text-sm1">
                  <div noValidate className="w-full">
                     <div className="w-full">
                         <label>Voces Disponibles</label>
                          <select onChange={handleVoiceChange} value={selectedVoice?.name || ''}>
                             {voices.map((voice, index) => (
                                 <option key={index} value={voice.name}>
                                    {voice.name} ({voice.lang}){voice.default ? " [default]" : ""}
                                 </option>
                               ))} 
                          </select>
                     </div>
                     <div className="flex flex-row gap-x-5 mt-4">
                       <div>
                          <label className="text-[0.89rem]">Tono (pitch): {pitch}</label>
                          <input type="range" min="0" max="2" step="0.1"  className='w-[6.9rem] h-[0.375rem]' value={pitch} onChange={e => setPitch(parseFloat(e.target.value))} />
                       </div>

                       <div>
                          <label className="text-[0.89rem]">Volumen: {volume}</label>
                          <input type="range" min="0" max="1" step="0.1" className='w-[6.9rem] h-[0.375rem]' value={volume} onChange={e => setVolume(parseFloat(e.target.value))} />
                       </div>
                 
                       <div>
                          <label className="text-[0.89rem]">Veloc.(rate): {rate}</label>
                          <input type="range" min="0.1" max="2" step="0.1" className='w-[6.9rem] h-[0.375rem]' value={rate} onChange={e => setRate(parseFloat(e.target.value))} />
                       </div>
                     </div>
                     <div className="mt-4">
                        <div className="flex flex-row items-center">
                           <label>Texto a escuchar</label>
                           <button onClick={speak} className="ml-2">
                              <Icon svg="speak" className="flex w-[2rem] h-[2rem] fill-gray-400 hover:fill-default" title="volumeSlash" />
                           </button>
                        </div>   
                        <textarea
                          rows={2}
                         value={texto}
                         onChange={(e) => setTexto(e.target.value)}
                        />
                     </div> 
                     <div className="mt-4 flex flex-row gap-x-5">
                        <div className="flex flex-col">
                           <label>Cant. Celdas</label>
                           <input type="number" className="flex w-[6rem]" value={celdas} onChange={e => setCelda(Number(e.target.value))}></input>
                        </div>   
                        <div className="flex flex-col">
                           <label>Altura(Rem)</label>
                           <input type="number" className="flex w-[6rem]" value={celdHeight} onChange={e => setHeight(parseFloat(e.target.value))}></input>
                        </div>   

                     </div>  
                        
                   <div className="flex w-full gap-4 mt-6 justify-end">
                     <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
                     <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
                   </div>
                
                  </div>
               </div>
          </Modal>            
    {showToast && (
        <Toasts type={opciones.type} message={opciones.message} active={opciones.active}>
          
        </Toasts>
                 )}
        
        </>
      );
    }
    ScreenConfig.propTypes = {
      show: PropTypes.bool.isRequired,
      handleshow: PropTypes.func.isRequired,
    };
    
    export default ScreenConfig;
    